export default function IconPhone (props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" {...props}>
      <circle strokeLinecap="round" fill="none" strokeDasharray="50.26548245743669 50.26548245743669" stroke="currentColor" strokeWidth="8" r="32" cy="50" cx="50">
      </circle>
    </svg>
  )
};
